define(function (require) {
	// general
	const favoriteContactItemView = require('civicsViews/favoriteContacts/v_itv_select_favorite');
	const EmptyView = require('civicsViews/favoriteContacts/v_lov_empty_view');
	// views

	return Marionette.CollectionView.extend({
		tagName: 'div',
		className: 'favorite-container',
		childView: favoriteContactItemView,
		emptyView: EmptyView,
		initialize: function (options) {
			this.config = options.config;
		},
		childViewOptions: function (model, index) {
		return {
			collection: this.collection,
			selectedFavorites: this.options.selectedFavorites,
			config: this.options.config,
			isInviteProcess: this.options.isInviteProcess
			};		
		},
		onRender: function () {
		},
	});
});
